import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './DigitalTransformation.css';

const transformationSteps = [
    {
        number: "01",
        title: "Analisi Digitale",
        description: "Valutiamo lo stato attuale dei tuoi processi digitali e identifichiamo le opportunità di miglioramento.",
        icon: "🔍",
        benefits: ["Audit completo", "Gap Analysis", "Roadmap strategica"]
    },
    {
        number: "02",
        title: "Strategia Digitale",
        description: "Definiamo una strategia su misura per trasformare i tuoi processi business attraverso la tecnologia.",
        icon: "🎯",
        benefits: ["Piano strategico", "KPI definiti", "Timeline chiara"]
    },
    {
        number: "03",
        title: "Implementazione",
        description: "Implementiamo le soluzioni tecnologiche necessarie per digitalizzare i tuoi processi aziendali.",
        icon: "⚡",
        benefits: ["Sviluppo software", "Integrazione sistemi", "Automazione"]
    },
    {
        number: "04",
        title: "Formazione & Supporto",
        description: "Formiamo il tuo team e forniamo supporto continuo per garantire il successo della trasformazione.",
        icon: "🎓",
        benefits: ["Training personalizzato", "Supporto 24/7", "Manutenzione"]
    }
];

const digitalAreas = [
    {
        title: "Automazione Processi",
        description: "Automatizziamo i processi manuali ripetitivi per ridurre errori e aumentare l'efficienza.",
        icon: "🤖",
        examples: ["Workflow automation", "Document management", "Processo approvazioni"]
    },
    {
        title: "Cloud Migration",
        description: "Migriamo i tuoi sistemi on-premise al cloud per maggiore scalabilità e sicurezza.",
        icon: "☁️",
        examples: ["AWS/Azure migration", "Backup automatici", "Disaster recovery"]
    },
    {
        title: "Data Analytics",
        description: "Trasformiamo i tuoi dati in informazioni utili per decisioni business consapevoli.",
        icon: "📊",
        examples: ["Business Intelligence", "Reporting automatico", "Predictive analytics"]
    },
    {
        title: "Digital Customer Experience",
        description: "Miglioriamo l'esperienza digitale dei tuoi clienti attraverso tecnologie innovative.",
        icon: "👥",
        examples: ["App mobile", "Portali self-service", "Chatbot AI"]
    }
];

function DigitalTransformation() {
    return (
        <div className="digital-transformation-page">
            {/* Hero Section */}
            <section className="dt-hero">
                <Container>
                    <Row className="align-items-center min-vh-75">
                        <Col lg={6}>
                            <div className="dt-hero-content fade-in-up">
                                <h1 className="dt-hero-title">
                                    {/*<span className="gradient-text">Digital Transformation</span> con BearSoftware*/}
                                    Digital Transformation con BearSoftware
                                </h1>
                                <p className="dt-hero-description">
                                    Guidiamo la tua azienda nel percorso di digitalizzazione:
                                    ottimizziamo i processi, riduciamo i costi e aumentiamo la competitività
                                    attraverso soluzioni tecnologiche su misura.
                                </p>
                                <div className="dt-hero-stats">
                                    <div className="stat-item">
                                        <h3>85%</h3>
                                        <p>Riduzione tempi processo</p>
                                    </div>
                                    <div className="stat-item">
                                        <h3>60%</h3>
                                        <p>Aumento produttività</p>
                                    </div>
                                    <div className="stat-item">
                                        <h3>40%</h3>
                                        <p>Riduzione costi operativi</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="dt-hero-image fade-in">
                                <div className="transformation-graphic">
                                    <div className="digital-icons">
                                        <div className="icon-item">📱</div>
                                        <div className="icon-item">☁️</div>
                                        <div className="icon-item">🤖</div>
                                        <div className="icon-item">📊</div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Cos'è la Digital Transformation */}
            <section className="dt-what section-padding">
                <Container>
                    <Row>
                        <Col lg={10} className="mx-auto">
                            <div className="text-center mb-5">
                                <h2 className="section-title">Cos'è la Digital Transformation?</h2>
                                <p className="section-subtitle">
                                    La trasformazione digitale è l'integrazione di tecnologie digitali in tutti
                                    gli aspetti di un'azienda, cambiando fondamentalmente il modo in cui operi e offri valore ai clienti.
                                </p>
                            </div>

                            <Row>
                                <Col lg={6} className="mb-4">
                                    <Card className="dt-info-card h-100">
                                        <Card.Body>
                                            <div className="info-icon">🚀</div>
                                            <h4>Innovazione Continua</h4>
                                            <p>
                                                Non è solo implementare nuove tecnologie, ma ripensare completamente
                                                i processi aziendali per creare valore in modo più efficace.
                                            </p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col lg={6} className="mb-4">
                                    <Card className="dt-info-card h-100">
                                        <Card.Body>
                                            <div className="info-icon">🎯</div>
                                            <h4>Focus sul Cliente</h4>
                                            <p>
                                                Mettere il cliente al centro, utilizzando i dati per comprendere
                                                meglio le sue esigenze e offrire esperienze personalizzate.
                                            </p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Come la implementiamo */}
            <section className="dt-process section-padding bg-light">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center mb-5">
                            <h2 className="section-title">Come Implementiamo la Digital Transformation</h2>
                            <p className="section-subtitle">
                                Il nostro approccio strutturato garantisce una trasformazione digitale efficace e sostenibile
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        {transformationSteps.map((step, index) => (
                            <Col lg={6} className="mb-4" key={index}>
                                <Card className={`dt-step-card fade-in-up`} style={{animationDelay: `${index * 0.2}s`}}>
                                    <Card.Body>
                                        <div className="step-header">
                                            <div className="step-number">{step.number}</div>
                                            <div className="step-icon">{step.icon}</div>
                                        </div>
                                        <h4 className="step-title">{step.title}</h4>
                                        <p className="step-description">{step.description}</p>
                                        <ul className="step-benefits">
                                            {step.benefits.map((benefit, idx) => (
                                                <li key={idx}>{benefit}</li>
                                            ))}
                                        </ul>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Aree di Intervento */}
            <section className="dt-areas section-padding">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center mb-5">
                            <h2 className="section-title">Aree di Intervento</h2>
                            <p className="section-subtitle">
                                Trasformiamo ogni aspetto del tuo business attraverso soluzioni digitali mirate
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        {digitalAreas.map((area, index) => (
                            <Col lg={6} className="mb-4" key={index}>
                                <Card className={`dt-area-card h-100 fade-in`} style={{animationDelay: `${index * 0.15}s`}}>
                                    <Card.Body>
                                        <div className="area-icon">{area.icon}</div>
                                        <h4 className="area-title">{area.title}</h4>
                                        <p className="area-description">{area.description}</p>
                                        <div className="area-examples">
                                            <h6>Esempi di implementazione:</h6>
                                            <ul>
                                                {area.examples.map((example, idx) => (
                                                    <li key={idx}>{example}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* CTA Section */}
            <section className="dt-cta section-padding">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center">
                            <h2 className="cta-title text-white">
                                Pronto per la Digital Transformation?
                            </h2>
                            <p className="cta-description text-white-50 mb-4">
                                Inizia il tuo percorso di trasformazione digitale con BearSoftware.
                                Contattaci per una consulenza gratuita e scopri come possiamo far crescere il tuo business.
                            </p>
                            <div className="cta-buttons">
                                <a href="#contact" className="btn-gradient me-3">
                                    <span>Richiedi Preventivo</span>
                                </a>
                                <Link to="/services" className="btn-outline">
                                    Vedi Tutti i Servizi
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default DigitalTransformation;